import React from 'react';  
import './index.css';
import { Tabs,WingBlank } from 'antd-mobile';
import { StickyContainer, Sticky } from 'react-sticky';
import TabIntro from '../tabIntro'
import TabReport from '../tabReport'
const tabs = [
  { title: '实验简介' },
  { title: '提交报告' },
];

function renderTabBar(props) {
  return (<Sticky>
    {({ style }) => <div style={{ ...style, zIndex: 20,top:'45px' }}><Tabs.DefaultTabBar {...props} /></div>}
  </Sticky>);
}
class InfoTab extends React.Component{
  render(){
    const {data,endtime,starttime,score} =this.props 

    return (
      <div className="info-tab">
       <StickyContainer>
          <Tabs tabs={tabs}
            swipeable={false}
            initalPage={'t2'}
            renderTabBar={renderTabBar}
            >
            <div className="tab-main">
              <WingBlank>
                <TabIntro data={data}/>
              </WingBlank>
            </div>
            <div className="tab-main">
              <WingBlank>
                <TabReport  data={data} starttime = {starttime} endtime={endtime} score={score}/>
              </WingBlank>
            </div>  
          </Tabs>
        </StickyContainer>
      </div>
      )
  }
}
export default InfoTab;